<div class="root">
    <div class="root__list" *ngIf="permits">
        <div *transloco="let t; read: 'permit.publicStatus'" class="root__legends">
            <ng-container *ngFor="let key of statusKeys()">
                <pmt-permit-public-status *ngIf="statusExists(PublicPermitStatus[key])" [status]="PublicPermitStatus[key]"></pmt-permit-public-status>
            </ng-container>
        </div>

        <div *ngIf="permits?.length <= 0" >
            <div *transloco="let t; read: 'permit'" class="root__noPermits">
                {{ t("noPermits") }}
            </div>
        </div>
        <pmt-permit-list-item [item]="permit" *ngFor="let permit of permits"></pmt-permit-list-item>

        <ng-container *ngIf="listType === PermitListType.Completed && (hasMoreCompletedPermits$ | async)">
            <div class="anchor root__fetch-more" [loading]="getAllCompletedAction" *transloco="let t; read: 'permit.list'" (click)="fetchMoreCompletedPermits()">
                {{ t("fetchMore") }}
            </div>
        </ng-container>
    </div>

    <div *ngIf="showScrollToTop" class="root__scroll-to-top" (click)="scrollToTop()">
        <ng-container *transloco="let t; read: 'permit.list'">
            <span class="root__scroll-to-top-text">{{ t("scrollToTop") }}</span>
        </ng-container>
    </div>
</div>
